import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Award, Map } from 'lucide-react';
const problems = [{
  number: '01 / 02',
  title: 'Sos uno más entre cientos de fabricantes sin identidad propia',
  without: 'Publicás tus muebles y nadie sabe quién sos ni por qué elegirte a vos y no a otro.',
  with: 'Tomo 7 — Kit de Marca Personal para Artesano Japandi: nombre de marca, paleta visual, bio, tono de comunicación e historia de origen que hace que la gente te elija y te pague más.'
}, {
  number: '02 / 02',
  title: 'No sabés qué hacer cada día para llegar a los $3000 USD',
  without: 'Tenés el sistema pero no sabés exactamente qué hacer el lunes, el miércoles ni el fin de mes.',
  with: 'Tomo 8 — Mapa de Ruta: Tus Primeros 90 Días como Fabricante Japandi. Un plan semana a semana para que en 3 meses hayas fabricado, fotografiado, publicado y cobrado tus primeras ventas. Sin improvisar.'
}];
const addons = [{
  icon: Award,
  number: 'T7',
  title: 'Kit de Marca Personal para Artesano Japandi',
  description: 'Nombre de marca, paleta visual, bio lista para Instagram y sistema de posicionamiento para que los clientes te busquen a vos.'
}, {
  icon: Map,
  number: 'T8',
  title: 'Mapa de Ruta: Tus Primeros 90 Días como Fabricante Japandi',
  description: 'Plan semana a semana para fabricar, vender y cobrar en los primeros 3 meses. Sin improvisar. Sin quedarte trabado.'
}];
export function ProAddons() {
  return <section className="py-8 md:py-16 px-4 bg-white" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-bold text-center mb-6 md:mb-12" data-id="element-216">
          ¿QUÉ AGREGA EL MEGAPACK PRO?
        </motion.h2>

        <p className="text-center text-sm md:text-lg mb-8 md:mb-12 text-[#2B2724]/80" data-id="element-217">
          Para fabricantes que quieren ir un paso más allá hacia el mercado
          premium
        </p>

        <div className="space-y-6 md:space-y-8 mb-8 md:mb-12" data-id="element-218">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#F5F0E8] rounded-lg p-4 md:p-8 border border-[#2B2724]/10" data-id="element-219">
              <div className="mb-4" data-id="element-220">
                <span className="text-[10px] md:text-xs font-semibold text-[#C2613A]" data-id="element-221">
                  Problema {problem.number}
                </span>
                <h3 className="text-base md:text-xl font-bold mt-1 md:mt-2" data-id="element-222">
                  {problem.title}
                </h3>
              </div>

              <div className="grid md:grid-cols-2 gap-3 md:gap-6" data-id="element-223">
                <div className="bg-red-50/50 p-3 md:p-4 rounded-lg border border-red-200/50" data-id="element-224">
                  <div className="flex items-start gap-2 mb-1 md:mb-2" data-id="element-225">
                    <X className="w-4 h-4 md:w-5 md:h-5 text-red-500 flex-shrink-0 md:mt-0.5" data-id="element-226" />
                    <span className="font-semibold text-xs md:text-sm" data-id="element-227">
                      Sin PRO
                    </span>
                  </div>
                  <p className="text-[10px] md:text-sm text-[#2B2724]/70" data-id="element-228">
                    {problem.without}
                  </p>
                </div>

                <div className="bg-green-50/50 p-3 md:p-4 rounded-lg border border-green-200/50" data-id="element-229">
                  <div className="flex items-start gap-2 mb-1 md:mb-2" data-id="element-230">
                    <Check className="w-4 h-4 md:w-5 md:h-5 text-[#8B9A8E] flex-shrink-0 md:mt-0.5" data-id="element-231" />
                    <span className="font-semibold text-xs md:text-sm" data-id="element-232">
                      Con PRO
                    </span>
                  </div>
                  <p className="text-[10px] md:text-sm font-medium" data-id="element-233">
                    {problem.with}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#2B2724] text-white rounded-lg p-5 md:p-8" data-id="element-234">
          <h3 className="text-lg md:text-2xl font-bold text-center mb-6 md:mb-8" data-id="element-235">
            MEGAPACK PRO INCLUYE ADEMÁS:
          </h3>

          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-236">
            {addons.map((addon, index) => {
            const Icon = addon.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm p-3 md:p-4 rounded-lg border border-white/20" data-id="element-237">
                  <div className="flex-shrink-0 flex items-center justify-center w-11 h-11 md:w-12 md:h-12 rounded-lg bg-[#C2613A]/20" data-id="element-238">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-[#C2613A]" data-id="element-239" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-240">
                    <h4 className="font-bold text-xs md:text-base leading-tight" data-id="element-241">
                      <span className="text-[#C2613A]" data-id="element-242">{addon.number}</span> ·{' '}
                      {addon.title}
                    </h4>
                    <p className="text-[10px] md:text-sm text-white/80 leading-snug mt-0.5" data-id="element-243">
                      {addon.description}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}